import { MARKET_MODELING_PERSONAS, resolveMarketModelingPersona } from 'features/market-modeling/utils/marketModelingScenarioConfig'

export const MarketModelingStoreKeys = {
  MARKET_MODELING: 'market_modeling',
}

export const MARKET_MODELING_VIEW_MODES = {
  OVERVIEW: 'overview',
  TABLE: 'table',
  SCATTERPLOT: 'scatterplot',
}

const APP_SUB_TABS = [
  {
    name: 'Practice Setting',
    link: './practice-setting',
    code: 'mmpracticesettingtab',
  },
  {
    name: 'Specialty',
    link: './specialty',
    code: 'mmspecialtytab',
  },
  {
    name: 'Incumbent',
    link: './incumbent',
    code: 'mmincumbenttab',
  },
]

const PHY_SUB_TABS = [
  {
    name: 'Specialty Group',
    link: './specialty-group',
    code: 'mmspecialtygrouptab',
  },
  {
    name: 'Specialty',
    link: './specialty',
    code: 'mmspecialtytab',
  },
  {
    name: 'Incumbent',
    link: './incumbent',
    code: 'mmincumbenttab',
  },
]

const MARKET_MODELING_MODE_TABS = [
  {
    id: MARKET_MODELING_VIEW_MODES.OVERVIEW,
    label: 'Overview',
    isDisabled: false,
    hidden: false,
  },
  {
    id: MARKET_MODELING_VIEW_MODES.TABLE,
    label: 'Table',
    isDisabled: false,
    hidden: false,
  },
  {
    id: MARKET_MODELING_VIEW_MODES.SCATTERPLOT,
    label: 'Scatterplot',
    isDisabled: false,
    hidden: false,
  },
]

export function getMarketModelingSubTabs(appSelected = '') {
  return resolveMarketModelingPersona(appSelected) === MARKET_MODELING_PERSONAS.APP ? APP_SUB_TABS : PHY_SUB_TABS
}

export function getMarketModelingDefaultSubroute(appSelected = '') {
  return resolveMarketModelingPersona(appSelected) === MARKET_MODELING_PERSONAS.APP ? 'practice-setting' : 'specialty-group'
}

export function getMarketModelingDatasourceKey(appSelected = '') {
  return MarketModelingStoreKeys.MARKET_MODELING + resolveMarketModelingPersona(appSelected)
}

export function getMarketModelingModeTabs() {
  return MARKET_MODELING_MODE_TABS
}
